// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aEQCBGnfd3acHN {
  color: var(--ds-text-subtlest, #626f86);
}
.sfyxz0HRQWWT4C {
  display: block;
  max-width: 600px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: 75px auto;
  text-align: center;
}
.sfyxz0HRQWWT4C h1 {
  margin-bottom: var(--ds-space-300, 24px);
  font-size: 26px;
}
.sfyxz0HRQWWT4C p {
  font-size: 18px;
  line-height: 22px;
}
.sfyxz0HRQWWT4C.dPpRMGQI6dXyCs {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 35px;
}
.sfyxz0HRQWWT4C.dPpRMGQI6dXyCs h1 {
  margin-top: var(--ds-space-250, 20px);
}
.Ne3FKhbCiJl6RF {
  margin-top: var(--ds-space-400, 32px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
}
.Ne3FKhbCiJl6RF a {
  color: var(--ds-link, #0c66e4);
}
.Q4kPWGILveBkRh {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: var(--ds-space-400, 32px);
  gap: var(--ds-space-150, 12px);
}
.Q4kPWGILveBkRh button {
  min-width: 200px;
}
`, ""]);
// Exports
export var quiet = `aEQCBGnfd3acHN`;
export var bigMessage = `sfyxz0HRQWWT4C`;
export var withPicture = `dPpRMGQI6dXyCs`;
export var littleMessage = `Ne3FKhbCiJl6RF`;
export var ctaContainer = `Q4kPWGILveBkRh`;
export default ___CSS_LOADER_EXPORT___;
